import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'
import config from '@/config'

const opscenterBaseUrl = config.baseOpsCenterUrl + '/opscenter/api/v1/'
const saltapiBaseUrl = config.saltapiBaseUrl + '/api/salt/file'
const baseHeadersFile = {
  'Authorization': 'OPS ' + getToken(),
  'Content-Type': 'multipart/form-data'
}
const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const saveFileUpload = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'upload',
    headers: baseHeadersFile,
    data: data,
    method: 'post'
  })
}

export const fileUpload = (data) => {
  return axios.request({
    url: saltapiBaseUrl,
    headers: baseHeadersFile,
    data: data,
    method: 'post'
  })
}

export const getFileHistoryList = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'file/history/list',
    headers: baseHeaders,
    method: 'get',
    params: params
  })
}
